import Vue from 'vue'
import App from './App.vue'
import { router } from './plugins/router'
import { store } from './store/store'
import ElementUI from './plugins/element'
import VueSidebarMenu from './plugins/sidebar'
import vueDragAndDropList from 'vue-drag-and-drop-list'
import Firebase, { isCache } from './plugins/firebase'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import 'vue-select/dist/vue-select.css'
import firebase from 'firebase'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import VueClipboard from 'vue-clipboard2'
import AsyncComputed from 'vue-async-computed'
import AutoCleanup from './plugins/autoCleanup'

Vue.config.productionTip = false
Vue.use(VueSidebarMenu)
Vue.use(Firebase)
Vue.use(AutoCleanup)
Vue.use(vueDragAndDropList)
Vue.use(ElementUI, { locale })
Vue.use(VueClipboard)
dayjs.extend(utc)
dayjs.locale('ru')
Vue.use(AsyncComputed)


const initApp = () => {
  Firebase.auth().onAuthStateChanged(() => {
    if (window.location.hash === '#/registration?lock=1') {
      return
    }

    // if (!isCache) {
    //   Object.keys(localStorage)
    //     .filter(key => key.startsWith('USER'))
    //     .forEach(key => localStorage.removeItem(key))
    //   Object.keys(localStorage)
    //     .filter(key => key.startsWith('JOB'))
    //     .forEach(key => localStorage.removeItem(key))
    //   Object.keys(localStorage)
    //     .filter(key => key.startsWith('PERM'))
    //     .forEach(key => localStorage.removeItem(key))
    //   Object.keys(localStorage)
    //     .filter(key => key.startsWith('ZONES'))
    //     .forEach(key => localStorage.removeItem(key))
    //   Object.keys(localStorage)
    //     .filter(key => key.startsWith('OBJECT'))
    //     .forEach(key => localStorage.removeItem(key))
    // }

    new Vue({
      el: '#app',
      store,
      router,
      render: h => h(App),
    })

    if (!firebase.auth().currentUser) {
      localStorage.removeItem('company')
    }
  })
}

initApp()


document.getElementById('reload').onclick = initApp



// WEBPACK FOOTER //
// ./src/main.js